export function buildMapUrl(coordinates: [number, number]) {
  const latitude = coordinates[1];
  const longitude = coordinates[0];
  return `https://www.openstreetmap.org/?mlat=${latitude}&mlon=${longitude}`;
}
